<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title class="text-h5">
          Buntblock
        </v-card-title>
        <v-card-subtitle>
          <v-row>
            <v-col sm="2">
              <v-text-field v-model="customerId" 
                            outlined
                            label="Kundnummer"
                            type="number"                                               
                            class="input" 
                            @keyup.enter="search()"
              >
                <template v-slot:append-outer>
                  <v-btn icon 
                         @click="search()"
                  >              
                    <v-icon>mdi-magnify</v-icon>                              
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
              
            <v-col sm="1" class="mt-3">
              <v-btn class="warning"
                     @click="reset"
              >
                Rensa
              </v-btn>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-text>
          <v-data-table       
            :headers="headers"
            :items="bundles"
            :items-per-page="10"
            :loading="loading"
            loading-text="Laddar buntar"
            class="elevation-1"
          >
            <template v-slot:item.fromDate="{ item }">
              <span>{{ item.fromDate | toLocalDate }}</span>
            </template>
            <template v-slot:item.toDate="{ item }">
              <span>{{ item.toDate | toLocalDate }}</span>
            </template>
            <template v-slot:item.actions="{ item }">      
              <v-icon
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import api from '@/backend/adminapi'
import log from '@/logger'
import _ from 'lodash'
export default{
    name:'BundleList',
    data() {
        return {
            bundles: [],    
            loading: false,
            customerId: undefined,                                  
            headers: [
              { text: 'Beställt datum', align: 'start', value: 'fromDate' },
              { text: 'Bäst före', value: 'toDate' },
              { text: 'Buntnr fr.o.m.', value: 'fromNumber' },
              { text: 'Buntnr t.o.m.', value: 'toNumber' },
              { text: 'Antal oanvända', value: 'numberUnused' },
              { text: 'Ursprung', value: 'status' },
              { text: '', value: 'actions', sortable: false },
            ],            
        }
    },
    computed:{   
    },
    watch: { 
      customerId: function() { // watch it          
         this.bundles = []        
         this.loading = false              
      },      
    },
    mounted() {        
      
    },
    methods: {
        search(){
          this.loadData()  
        },
        reset(){
          this.customerId = undefined
      
        },
        loadData() {
            this.loading = true
            let self= this
            api.adminGetBundleBlocks(this.customerId)
            .then((resp) => {
                this.bundles = resp.data
                self.loading = false
                log.debug('Bundles:' + resp.data)                
            }).catch((error) => {
                self.loading = false
                log.debug('Error uploading file:', error)
            })            
        },
        deleteItem(bundle){
          log.debug('Delete id:'+ bundle.id)  
          let self= this
          api.adminDeleteBundleBlocks(this.customerId,bundle.id)
            .then((resp) => {
                if(resp.status===200){
                  this.bundles = _.reject(this.bundles, function(item) {return (item.id === bundle.id)})
                 
                }                
                log.debug('Bundles:' + resp.data)                
            }).catch((error) => {
                self.loading = false
                log.debug('Error uploading file:', error)
            })
            
        },
        
    }
}
</script>

<style scoped>
span {
    font-size: 1em;
}

.input >>> input[type="number"] {
  appearance: textfield;  
  -moz-appearance: textfield;  
}
.input >>> input::-webkit-outer-spin-button,
.input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

</style>